var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { attrs: { "data-qa": "price_free" } }, [
    _c("div", { staticClass: "d-flex align-center gc-3 mb-1" }, [
      _c(
        "div",
        {
          staticClass: "text-h6 text-success--text d-flex align-center gc-1",
          attrs: { "data-qa": "price_free_text" },
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_setup.t("Бесплатно", _setup.options)) +
              "\n      "
          ),
          _c("img", {
            attrs: {
              src: "/static/_v1/pd/icons/ui-kit/promotion/tag-discount.svg",
              alt: _setup.t("Иконка Акции", _setup.options),
              width: "20",
              height: "20",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "text-body-2 text-secondary--text text-decoration-line-through",
          attrs: { "data-qa": "price_free_num" },
        },
        [
          _vm._v(
            "\n      " + _vm._s(_setup.getFormattedPrice(_vm.price)) + "\n    "
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "text-caption text--text",
        attrs: { "data-qa": "price_free_desc" },
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(
              _setup.t(
                "Консультация бесплатна при условии дальнейшего лечения. Подробности уточняйте в клинике.",
                _setup.options
              )
            ) +
            "\n  "
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }